import React from "react";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";

const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
}) => {
  // Convert to numbers to prevent NaN
  const page = Number(currentPage) || 1;
  const pages = Number(totalPages) || 1;
  const items = Number(totalItems) || 0;
  const perPage = Number(itemsPerPage) || 10;

  if (pages <= 1) return null;

  const startItem = (page - 1) * perPage + 1;
  const endItem = Math.min(page * perPage, items);

  return (
    <div className="pagination-wrapper">
      <div className="pagination-info">
        Showing {startItem} to {endItem} of {items} entries
      </div>
      <div className="pagination">
        <button
          className="pagination-btn"
          onClick={() => onPageChange(1)}
          disabled={page === 1}
        >
          First
        </button>
        <button
          className="pagination-btn"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
        >
          <MdKeyboardDoubleArrowLeft />
        </button>

        {[...Array(pages)].map((_, index) => {
          const pageNum = index + 1;
          if (
            pageNum === 1 ||
            pageNum === pages ||
            (pageNum >= page - 1 && pageNum <= page + 1)
          ) {
            return (
              <button
                key={pageNum}
                className={`pagination-btn ${page === pageNum ? "active" : ""}`}
                onClick={() => onPageChange(pageNum)}
              >
                {pageNum}
              </button>
            );
          } else if (pageNum === page - 2 || pageNum === page + 2) {
            return (
              <span key={pageNum} className="pagination-dots">
                ...
              </span>
            );
          }
          return null;
        })}

        <button
          className="pagination-btn"
          onClick={() => onPageChange(page + 1)}
          disabled={page === pages}
        >
          <MdKeyboardDoubleArrowRight />
        </button>
        <button
          className="pagination-btn"
          onClick={() => onPageChange(pages)}
          disabled={page === pages}
        >
          Last
        </button>
      </div>
    </div>
  );
};

export default Pagination;
